import { useEffect } from 'react';
import { Box, Divider, useMediaQuery, Link } from '@mui/material';
import Header from '../components/header';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import useLanguage from '../useLanguage';

const NewsPage = () => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const newsItems = [
        // {
        //     date: "2025.02.01",
        //     text: t('News 3'),
        //     link: "https://shop.reparu.jp"
        // },
        // {
        //     date: "2025.02.01",
        //     text: t('News 2'),
        //     link: "https://customer.reparu.jp"
        // },
        {
            date: "2024.06.06",
            text: t('News 1')
        }
    ]

    const { language }= useLanguage();

    useEffect(() => {
        i18n.changeLanguage(language);
    }, []);


    return (
        <div
            style={{
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'auto',
            }}
        >
            <Header textColor="#000000" backgroundColor="white"/>
            <Box component="main" sx={{ flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                mt: 12,
                ml: isMobile? 3 : 8,
                pt: '64px'
            }}>
                <h1 style={{ fontSize: isMobile? '2rem' : '4rem', marginBottom: '0.5rem' }}>News.</h1>
                {i18n.language === 'ja' && (
                    <h3 style={{ marginTop: '0' }}>ニュース</h3>
                )}
                {isMobile && 
                    <Divider sx={{ mt: 3, mb: 3, mr: 2 }} />
                }
                {newsItems.map((item) => (
                    <>
                        <Box sx={{ mt: isMobile? 0 : 3, display: isMobile? '' : 'flex', alignItems: 'center' }}>
                            <span style={{ fontSize: '1rem', width: '15rem' }}>{item.date}</span>
                            {/* {isMobile ? (
                                    <Box sx={{ mt: 1, display: 'flex', alignItems: 'center' }}>
                                        {item.link ? (
                                            <Link 
                                                href={item.link} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                sx={{ fontSize: '1rem', color: '#0056b3', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                                            >
                                                {item.text}
                                            </Link>
                                        ) : (
                                            <span style={{ fontSize: '1rem' }}>{item.text}</span>
                                        )}
                                    </Box>
                                ) 
                                :
                                (
                                    item.link ? (
                                        <Link 
                                            href={item.link} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            sx={{ fontSize: '1rem', color: '#0056b3', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                                        >
                                            {item.text}
                                        </Link>
                                    ) : (
                                        <span style={{ fontSize: '1rem' }}>{item.text}</span>
                                    )
                                )
                            } */}
                            <span style={{ fontSize: '1rem' }}>{item.text}</span>
                        </Box>
                        <Divider sx={{ mt: 3, mb: 3, mr: isMobile? 2 : 20 }} />
                    </>
                ))}
            </Box>
        </div>

    )
}

export default NewsPage;